module.exports = __webpack_public_path__ + "media/src/images/example_voucher_card_en-58477f35d882308ea462a80a32206abc.jpg";